var EPK = EPK || {};

EPK.ProductCategory = EPK.ProductCategory || {};

EPK.ProductCommon = EPK.ProductCommon || {};
EPK.ProductCommon = function(){};

EPK.ProductCommonParams = EPK.ProductCommonParams || {};

$(function(){
	var swiper = $('#slider-recommend-01').swiper({
		loop: true,
		centeredSlides: true,
		slidesPerView: 'auto',
		nextButton: '.slider-fwd',
		prevButton: '.slider-rev',
		pagination: '.slider-count',
		paginationType: 'fraction'
	});

	EPK.ProductCategory.getLocation();

	/**
	 * SP版
	 */

	if(EPK.ProductCommonParams.isSP){
		EPK.ProductCommon.getMinPrice('popularity', 3, 1);
		EPK.ProductCommon.getMinPrice('recommend', 4, 1);
		EPK.ProductCommon.getMinPrice('new', 11, 1);

	/**
	 * PC版
	 */

	}else{
		EPK.ProductCommon.getMinPrice('popularity', 5, 1);
		EPK.ProductCommon.getMinPrice('recommend', 5, 1);
		EPK.ProductCommon.getMinPrice('new', 10, 1);

		// 取扱店舗数取得処理
		EPK.ProductCommon.getItemShopCount('popularity', 1);
		EPK.ProductCommon.getItemShopCount('recommend', 1);
	}

});

/**
 * 現在地（緯度経度）取得処理
 * ※※位置情報取得できない場合のハンドリングが必要なので
 * ※※共通処理(EPK.common.currentPlaceCallback)は利用しない
 *
 */
EPK.ProductCategory.getLocation = function() {

	function successFunc(position) {
		var $data = position.coords ;
		var $lat = $data.latitude;
		var $lng = $data.longitude;

		doAttributeParams($lat, $lng);
	}

	function errorFunc() {
		doAttributeParams(1, 1);
	}

	function doAttributeParams(lat, lng) {
		$.each($('.top-itemlist').find('a'), function(index, val) {
			var href = $(val).prop('href');
			$(val).prop('href', href + '?lat=' + lat + '&lng=' + lng + '&sort=close');
		});
	}

	var tmpLat = Cookies.get('lat');
	var tmpLng = Cookies.get('lng');
	if(tmpLat && tmpLng) {
		successFunc({coords: {latitude: tmpLat*1.0, longitude: tmpLng*1.0}});
		return;
	}

	var optionObj = {
		"enableHighAccuracy": true,
		"timeout": 8000,
		"maximumAge": 2000,
	};

	// Geolocation APIの対応判定
	if(navigator.geolocation) {
		// 現在位置を取得
		navigator.geolocation.getCurrentPosition(successFunc, errorFunc, optionObj);
	}else {
		errorFunc();
	}
};
